module.exports = __webpack_public_path__ + "img/7.4ab6714f.jpg";